import {DecimalPipe} from '@angular/common';
import {Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiModulesService} from 'src/app/api-modules.service';
import {NgbdSortableHeader, SortEvent} from 'src/app/shared/directives/NgbdSortableHeader';

@Component({
    selector: 'app-list-page',
    templateUrl: './scrapped-user-list.component.html',
    styleUrls: ['./scrapped-user-list.component.scss']
})
export class ScrappedUserListComponent implements OnInit {
    public selected = [];
    public searchText;
    public editID: any;
    visible: any = true;
    public username = [];

    countries = [];
    data: any[] = [];
    filterParams: any = {};
    sortField: any = '';
    sortOrder: any = '';
    searchQuery: any = '';

    // Pagination
    currentPage = 1;
    total = 0;

    constructor(private apiModulesService: ApiModulesService) {

    }

    @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

    onSort({column, direction}: SortEvent) {

        this.headers.forEach((header) => {
            if (header.sortable !== column) {
                header.direction = '';
            }
        });
        this.sortField = column;
        this.sortOrder = direction;
        this.loadData();
    }

    onSelect(selected) {
        console.log(selected.target.value);
        this.filterParams.page = 1;
        this.loadData();
    }

    onSelectOwned(selected) {
        console.log(selected.target.value);
        this.filterParams.page = 1;
        this.loadData();
    }


    ngOnInit(): void {
        this.filterParams.country_id = '';
        this.getCountriesName();
        this.loadData();
    }

    loadData() {
        console.log(this.filterParams);
        this.apiModulesService.getData('telegram/scrapped-user/list', this.filterParams, this.sortField, this.sortOrder, this.searchQuery)
            .subscribe((response: any) => {
                this.data = response.data;
                this.currentPage = response.current_page;
                this.total = response.total;
            });
    }

    clearFilter() {
        this.filterParams.page = 1;
        this.filterParams.country_id = '';
        this.filterParams.username = '';
        this.filterParams.first_name = '';
        this.filterParams.channel_name = '';
        this.loadData();
    }

    applySort() {
        this.loadData();
    }

    applySearch() {
        this.filterParams.page = 1;
        this.loadData();
    }

    public getCountriesName() {
        this.apiModulesService.get('telegram/country/list').subscribe((data) => {
            this.countries = data;
        });
    }

    /**
     * Write code on Method
     *
     * @return response()
     */
    pageChangeEvent(event: number) {
        this.currentPage = event;
        this.filterParams.page = this.currentPage;
        this.loadData();
    }

}
